<template>
  <a
    class="whatsapp"
    :href="whatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Hubungi kami melalui WhatsApp"
    title="Hubungi kami"
  >
    <svg
    class="whatsapp-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    >
    <path
        d="M20 11.5C20 15.09 16.42 18 12 18C10.8 18 9.67 17.79 8.67 17.42L4 19L5.42 15.55C4.53 14.44 4 13.03 4 11.5C4 7.91 7.58 5 12 5C16.42 5 20 7.91 20 11.5Z"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    </svg>
  </a>
</template>

<script>
export default {
  name: 'WhatsappComponent',

  data() {
    return {
      phoneNumber: '6283139586001'
    }
  },

  computed: {
    whatsappUrl() {
      return `https://wa.me/${this.phoneNumber}`
    }
  }
}
</script>

<style scoped lang="scss">
.whatsapp {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1300;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 54px;
  height: 54px;
  padding: 0;

  color: var(--color-text-button);
  background: var(--color-button);
  border-radius: 50%;

  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.14);

  text-decoration: none;
  cursor: pointer;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 7px 20px rgba(0, 0, 0, 0.2);
    background: var(--color-button-hover);
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus-visible {
    outline: 2px solid #25d366;
    outline-offset: 4px;
  }
}

.whatsapp-icon {
  display: block;
  width: 25px;
  height: 25px;
}

@media (max-width: 768px) {
  .whatsapp {
    right: 16px;
    bottom: 16px;

    width: 48px;
    height: 48px;
  }

  .whatsapp-icon {
    width: 23px;
    height: 23px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .whatsapp {
    transition: none;
  }
}
</style>